import { Route, Routes } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
import { DownloadPage } from '../pages/DownloadPage';
import { HomePage } from '../pages/HomePage';
import { LegalDocumentPage } from '../pages/LegalDocumentPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { PrivacyPage } from '../pages/PrivacyPage';
import { ProofPage } from '../pages/ProofPage';

const privacyPolicyPage = (
  <LegalDocumentPage
    documentKey="privacy"
    titleKey="seo.privacyPolicy.title"
    descriptionKey="seo.privacyPolicy.description"
  />
);

const termsPage = (
  <LegalDocumentPage
    documentKey="terms"
    titleKey="seo.terms.title"
    descriptionKey="seo.terms.description"
  />
);

const deleteAccountPage = (
  <LegalDocumentPage
    documentKey="deleteAccount"
    titleKey="seo.deleteAccount.title"
    descriptionKey="seo.deleteAccount.description"
  />
);

export function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/proof/:proofId?" element={<ProofPage />} />
        <Route path="/privacy" element={privacyPolicyPage} />
        <Route path="/privacy-policy" element={privacyPolicyPage} />
        <Route path="/privacy-overview" element={<PrivacyPage />} />
        <Route path="/terms" element={termsPage} />
        <Route path="/terms-of-use" element={termsPage} />
        <Route path="/delete-account" element={deleteAccountPage} />
        <Route path="/account-deletion" element={deleteAccountPage} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Footer />
    </>
  );
}
